export enum PHPermissions {
	AllowDownloadData = 'allow-download-data',
	Control = 'ph-control',
	Analytics = 'ph-analytics',
	InstrumentEdit = 'ph-instrument-edit',
	InstrumentView = 'ph-instrument-view',
	PlanEdit = 'ph-plan-edit',
	PlanogramEdit = 'ph-planogram-edit',
	PlanogramView = 'ph-planogram-view',
	PlanView = 'ph-plan-view',
	ProductImageEdit = 'ph-product-image-edit',
	ProductParametersEdit = 'ph-product-parameters-edit',
	ProductView = 'ph-product-view'
}